/* Recipe V2 Client barrel export */

import { RecipeV2ClientApi } from './recipeV2ClientApi';

// Re-export types
export * from './recipeV2Types';

// Recipe V2 has a real backend for basic CRUD (Slice 1) - unfinished features still fall
// back to mocked behaviour inside RecipeV2ClientApi.
const recipeV2Client = new RecipeV2ClientApi();

export { recipeV2Client };
export { RecipeV2ClientMocked } from './recipeV2ClientMocked';
export type { IRecipeV2Client } from './IRecipeV2Client';
